/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestFormRejectModel
 */
export interface RequestFormRejectModel {
    /**
     * 
     * @type {string}
     * @memberof RequestFormRejectModel
     */
    note?: string | null;
}

export function RequestFormRejectModelFromJSON(json: any): RequestFormRejectModel {
    return RequestFormRejectModelFromJSONTyped(json, false);
}

export function RequestFormRejectModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestFormRejectModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function RequestFormRejectModelToJSON(value?: RequestFormRejectModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'note': value.note,
    };
}

